import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Eye, EyeOff } from "lucide-react";
import { Brand } from "@/components/Layout";
import { api, errMsg, tokens } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [reveal, setReveal] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      tokens.admin.set(r.token);
      nav("/admin/dashboard");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-md border border-slate-200 bg-white p-8" data-testid="admin-login-form">
        <Brand compact />
        <h1 className="mt-6 flex items-center gap-2 text-xl font-semibold text-slate-900">
          <Lock className="h-4 w-4" /> Admin sign in
        </h1>
        <label className="label-caps mt-6 block" htmlFor="admin-email">Email</label>
        <input id="admin-email" data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          className="mt-2 w-full rounded-md border border-slate-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-slate-900" />
        <label className="label-caps mt-4 block" htmlFor="admin-password">Password</label>
        <div className="relative mt-2">
          <input id="admin-password" type={reveal ? "text" : "password"} data-testid="admin-password-input"
            value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
            className="w-full rounded-md border border-slate-300 px-4 py-2.5 pr-11 focus:outline-none focus:ring-2 focus:ring-slate-900" />
          <button type="button" data-testid="admin-password-reveal" onClick={() => setReveal(!reveal)}
            aria-label={reveal ? "Hide password" : "Show password"}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700">
            {reveal ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
        <button type="submit" data-testid="admin-login-btn" disabled={busy}
          className="mt-6 w-full rounded-md bg-slate-900 px-5 py-3 font-semibold text-white disabled:opacity-40">
          {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
